var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiRsWhiteHeart = function SvgFiRsWhiteHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1"
  })));
};
export { SvgFiRsWhiteHeart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJjdXJyZW50Q29sb3IiIHZpZXdCb3g9IjAgMCAyMCAyMCIgaGVpZ2h0PSIyMCIgd2lkdGg9IjIwIj4KICA8cGF0aCBkPSJNNCAxYzIuMjEgMCA0IDEuNzU1IDQgMy45MkM4IDIuNzU1IDkuNzkgMSAxMiAxczQgMS43NTUgNCAzLjkyYzAgMy4yNjMtMy4yMzQgNC40MTQtNy42MDggOS42MDhhLjUxMy41MTMgMCAwMS0uNzg0IDBDMy4yMzQgOS4zMzQgMCA4LjE4MyAwIDQuOTIgMCAyLjc1NSAxLjc5IDEgNCAxeiIgLz4KPC9zdmc+";